<template>
  <div id="HomeTitle">
    <p class="home-title">
      <span class="title-name color000">{{ data.title }}</span><span class="more color999" v-if="data.more" @click="moreHandle">更多</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "HomeTitle",
  props: {
    data:{
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    moreHandle() {
      this.$emit("moreHandle");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/theme/theme";
.home-title {
  height: 43px;
  line-height: 43px;
  box-sizing: border-box;
  display: -webkit-flex;/* Safari */
  span.title-name{
    display: inline-flex;
    flex: 1;
    font-weight: 600;
    @extend .font18;
  }
  span.more{
    @extend .font13;
  }
}
</style>